import {queryLocales} from '@wix/ambassador-multilingual-locales-v2-locale/http';
import {getSiteLanguagesV2, Languages} from '@wix/multilingual-languages-utils';

import {editorReadyContext} from '@/editor.app';

export const createGetSiteLanguages = () => {
  return async (): Promise<Languages> => {
    const httpClient = editorReadyContext?.flowAPI?.httpClient;

    if (!httpClient) {
      throw new Error('HttpClient not available in flowAPI');
    }

    const res = await httpClient.request(queryLocales({}));

    if (!res.data.locales || res.data.locales?.length === 0) {
      throw new Error('Site has no locales');
    }
    return getSiteLanguagesV2(res.data.locales);
  };
};
